export default "__VITE_PUBLIC_ASSET__131be63a__"